<script>
import HomeIcon from "../Icons/HomeIcon.vue";

export default {
  props: {
    href: {
      type: String,
      required: true,
    },
    as: {
      type: String,
      default: "li",
    },
  },
  data() {
    return {
      currentPath: window.location.pathname,
    };
  },
  methods: {
    currentPageIs(route) {
      return this.currentPath === route || this.currentPath === `${route}/`;
    },
  },
  components: {
    HomeIcon,
  },
};
</script>

<template>
  <component
    :is="as"
    class="nav-item"
    :class="{
      active:
        currentPageIs('/') ||
        currentPageIs('/patienten') ||
        currentPageIs('/rezept-express'),
    }"
  >
    <a :href="href">
      <i aria-label="Home-Symbol"><HomeIcon /></i>
      <span>Startseite</span>
    </a>
  </component>
</template>
